import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge56 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='預託金の償還請求とは' fontWeight={700} />
                <p>
                    預託金の償還請求とは、
                    <a href='/knowledge/4'>預託金</a>
                    制のゴルフ会員権において、据置期間の満了後に会員がゴルフ場へ「預けている預託金を返還してほしい」と申し出る具体的な手続きのことです。
                    <br />
                    預託金が返還されない問題そのものの背景や発生原因については
                    <a href='/knowledge/16'>預託金の償還</a>
                    で解説していますので、本記事では、実際に償還請求を行う際の手順や注意点に絞ってご紹介します。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='償還請求ができる時期' fontWeight={700} />
                <p>
                    償還請求は、入会時に定められた据置期間（10〜20年程度が一般的）が満了して初めて行えるのが原則です。会員権証書や入会時の契約書類に記載されている据置期間と満了日を、まず手元の書類で確認しましょう。
                    <br />
                    据置期間が自動的に延長される特約（自動継続条項）が設けられているゴルフ場もあるため、契約内容を正確に把握しないまま「もう請求できるはず」と思い込むのは禁物です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='償還請求の具体的な流れ' fontWeight={700} />

                <Heading3 title='ゴルフ場が定める手順に従い請求の意思を明確にする' />
                <p>据置期間満了後に償還を求める際は、ゴルフ場が定める手順に従い、既定の書面で請求を行います。</p>

                <Heading3 title='応じてもらえない場合の交渉' />
                <p>
                    ゴルフ場側が経営難などを理由に応じない場合は、個人で交渉を続けるよりも、会員権問題に詳しい弁護士や専門家に依頼するほうが、一部でも償還を受けられる可能性が高まります。専門家を介した交渉で預託金の一部償還に至った事例もあります。
                </p>

                <Heading3 title='ゴルフ場が民事再生・破産手続き中の場合' />
                <p>
                    ゴルフ場運営会社が民事再生や破産といった法的整理の手続きに入っている場合、償還請求権は債権届出など裁判所が定める手続きに従って行使する必要があり、通常の請求とは進め方が異なります。この場合は速やかに専門家へ相談しましょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    預託金の償還請求は、据置期間や契約内容の確認から専門家への相談まで、個人で対応するには手間のかかる手続きです。償還請求以外にも、預託金の仕組みや償還が難しい場合の売却という選択肢については
                    <a href='/knowledge/16'>預託金の償還</a>
                    でもご紹介していますので、あわせてご確認ください。
                    <br />
                    ご購入・ご売却の際にはゴルフ会員権の売買実績を有する住地ゴルフにまずはご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge56;
